"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiErrorCodes = exports.SysErrorCodes = exports.BipErrorCodes = exports.IfhErrorCodes = exports.BestDataTypeIds = exports.BestOpcodes = void 0;
// BEST opcodes
exports.BestOpcodes = {
    NOP: 0x00,
    PUSH_CONST: 0x01,
    PUSH_VAR: 0x02,
    POP: 0x03,
    ADD: 0x04,
    SUB: 0x05,
    MUL: 0x06,
    DIV: 0x07,
    MOD: 0x08,
    AND: 0x09,
    OR: 0x0a,
    XOR: 0x0b,
    NOT: 0x0c,
    JUMP: 0x0d,
    JUMP_IF_ZERO: 0x0e,
    CALL: 0x0f,
    RETURN: 0x10,
};
// BEST data types (numeric IDs for binary format)
exports.BestDataTypeIds = {
    STRING: 0x01,
    INT: 0x02,
    LONG: 0x03,
    FLOAT: 0x04,
    DOUBLE: 0x05,
    BINARY: 0x06,
};
// IFH (Interface Handler) error codes
exports.IfhErrorCodes = {
    OK: 0,
    TIMEOUT: 1,
    INVALID_RESPONSE: 2,
    NOT_SUPPORTED: 3,
};
// BIP (BEST Interpreter) error codes
exports.BipErrorCodes = {
    OK: 0,
    INVALID_OPCODE: 1000,
    STACK_UNDERFLOW: 1001,
    STACK_OVERFLOW: 1002,
    DIVISION_BY_ZERO: 1003,
};
// System error codes
exports.SysErrorCodes = {
    OK: 0,
    FILE_NOT_FOUND: 2000,
    IO_ERROR: 2001,
    PERMISSION_DENIED: 2002,
};
// API error codes
exports.ApiErrorCodes = {
    OK: 0,
    NOT_INITIALIZED: 3000,
    INVALID_ARGUMENT: 3001,
    BUSY: 3002,
};
//# sourceMappingURL=constants.js.map